import { Outlet, createFileRoute } from "@tanstack/react-router";

// Layout do blog. As páginas reais são os filhos: /blog/, /blog/{categoria}/
// e as respectivas páginas numeradas.
export const Route = createFileRoute("/blog")({
  component: () => <Outlet />,
});
